import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Dashboard from './Dashboard';
import DialogContainers from './DialogContainers';

export interface DashboardContainerProps extends RouteComponentProps { }

const DashboardContainer: FC<DashboardContainerProps> = (props) => {

    const { ...routeProps } = props;
    return (
        <>
            <Dashboard {...routeProps} />
            <DialogContainers />
        </>
    )
}


export default DashboardContainer